import { createContext, useContext, useState } from "react";

interface SelectedTeamContextValue {
    teamId: number;
    teamName: string | undefined;
    setTeam: (teamId: number, teamName: string) => void;
}

const SelectedTeamContext = createContext<SelectedTeamContextValue | undefined>(undefined);

const TEAM_ID_KEY = "hockeyly_selected_team_id";
const TEAM_NAME_KEY = "hockeyly_selected_team_name";

export const SelectedTeamProvider = ({ children }: { children: React.ReactNode }) => {
    const [teamId, setTeamId] = useState<number>(() => {
        const stored = localStorage.getItem(TEAM_ID_KEY);
        return stored ? Number(stored) : 527810;
    });
    const [teamName, setTeamName] = useState<string | undefined>(() => {
        return localStorage.getItem(TEAM_NAME_KEY) ?? undefined;
    });

    const setTeam = (id: number, name: string) => {
        setTeamId(id);
        setTeamName(name);
        localStorage.setItem(TEAM_ID_KEY, String(id));
        localStorage.setItem(TEAM_NAME_KEY, name);
    };

    return (
        <SelectedTeamContext.Provider value={{ teamId, teamName, setTeam }}>{children}</SelectedTeamContext.Provider>
    );
};

export const useSelectedTeam = (): SelectedTeamContextValue => {
    const context = useContext(SelectedTeamContext);
    if (!context) {
        throw new Error("useSelectedTeam must be used within a SelectedTeamProvider");
    }
    return context;
};
